var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWebRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20905 12.4314C8.18962 12.2695 8.17964 12.1087 8.17964 11.9672C8.17964 9.85561 9.92153 8.11372 12.0331 8.11372C13.0181 8.11372 13.9402 8.51085 14.6185 9.13016L14.2784 9.47622C14.2017 9.55287 14.1722 9.66492 14.2017 9.77113C14.2371 9.87136 14.3197 9.94808 14.4258 9.97166C14.4852 9.98356 16.4354 10.612 16.3112 10.587C16.4692 10.6397 16.7028 10.4712 16.6593 10.2391C16.6473 10.1796 16.2156 8.01319 16.2405 8.1373C16.2169 8.03116 16.1402 7.94269 16.0341 7.9132C15.9339 7.88371 15.8217 7.9132 15.7451 7.98984L15.4561 8.27293C14.5654 7.44134 13.3425 6.93408 12.0331 6.93408C9.26689 6.93408 7 9.20097 7 11.9672V11.979C7 12.1452 7.0076 12.2737 7.01644 12.372C7.02819 12.5023 7.12418 12.6089 7.25244 12.6347L7.85831 12.7558C8.05553 12.7953 8.23286 12.6299 8.20905 12.4314Z",
    fill: "#2297FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.043 11.2993L16.4354 11.1755C16.2379 11.1353 16.0594 11.3008 16.0836 11.5002C16.1047 11.6723 16.1141 11.8397 16.1141 11.9672C16.1141 14.0788 14.3722 15.8207 12.2606 15.8207C11.2756 15.8207 10.3535 15.4236 9.67519 14.7984L10.0153 14.4582C10.092 14.3816 10.1215 14.2695 10.092 14.1633C10.0566 14.063 9.97402 13.9864 9.86788 13.9628C9.80851 13.9508 7.85827 13.3224 7.98245 13.3474C7.88215 13.3297 7.78185 13.3592 7.71703 13.43C7.64622 13.4949 7.61673 13.601 7.6344 13.6954C7.64638 13.7547 8.07822 15.9015 8.05326 15.7774C8.07676 15.8836 8.15348 15.9721 8.25962 16.0015C8.38273 16.0324 8.48549 15.9951 8.54862 15.9249L8.83178 15.6418C9.72234 16.4734 10.9453 17.0004 12.2606 17.0004C15.0268 17.0004 17.2937 14.7335 17.2937 11.9672V11.9495C17.2937 11.8188 17.2889 11.6904 17.278 11.5629C17.2668 11.4326 17.1712 11.3255 17.043 11.2993Z",
    fill: "#2297FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E9F4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWebRefresh);
export default __webpack_public_path__ + "static/media/ic_web_refresh.31648cac22f89d0b1054602163e5ce6f.svg";
export { ForwardRef as ReactComponent };